import React, { Suspense, lazy, useEffect } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { routes } from 'utils/routers.constants';
import Route from './Route';
import { getUserInfo, getSubSellers } from 'store/reducers/user.reducer';
import { getAvailableUsers } from 'store/reducers/subseller.reducer.js';
import PaymentPlan from 'views/PaymentPlan';
import ReadPlan from 'views/PaymentPlan/pages/ReadPlan';

const SignIn = lazy(() => import('views/SignIn/SignIn'));
const RecoverPassword = lazy(() => import('views/RecoverPassword/RecoverPassword'));
const ResetPassword = lazy(() => import('views/ResetPassword/ResetPassword'));
const SalesReports = lazy(() => import('views/SalesReports/SalesReports'));
const SalesDetails = lazy(() => import ('views/SalesReports/SalesDetails'));
const FinancialAgenda = lazy(() => import('views/FinancialAgenda/FinancialAgenda'));
const AllReports = lazy(() => import('views/ReceivablesReports/ReceivablesReports'));
const ChangePassword = lazy(() => import('views/ChangePassword/ChangePassword'));
const Finances = lazy(() => import('views/Finances/Finances'));
const UsersManagement = lazy(() => import ('views/UsersManagement/UsersManagement'));
const Subsellers = lazy(() => import ('views/Subsellers/Subsellers'));
const Schedules = lazy(() => import ('views/Schedules/Schedules'));
const Reconciliation = lazy(() => import ('views/Reconciliation/Reconciliation'));
const DetailsReconciliation = lazy(() => import ('views/Reconciliation/DetailsReconciliation'));
const PixKeyPage = lazy(() => import ('views/PixKeyPage/PixKeyPage'));
const WebhookDetails = lazy(() => import ('views/PaymentPlan/pages/WebhookDetails'));
const Support = lazy(() => import ('views/Support/Support'));
const Home = lazy(() => import ('views/Home'));
const Summary = lazy(()=> import ('views/Summary'));
const Faq = lazy(()=> import ('views/Faq'));
const PaymentBatches = lazy(()=> import ('views/PaymentOrders/PaymentBatches'));
const PaymentBatchOrders = lazy(()=> import ('views/PaymentOrders/PaymentBatchOrders'));
const SellersBalances = lazy(()=> import ('views/SellersBalances/SellersBalances'));
const SimBank = lazy(()=> import ('views/SimBank/SimBank'));

const Routes = () => {
  const dispatch = useDispatch();
  const { admin, manageReconciliation, superAdmin } = useSelector(({ User }) => User);
  const { loggedIn } = useSelector(({ Auth }) => Auth);

  useEffect(() => {
    if (loggedIn) {
      dispatch(getUserInfo());
      dispatch(getSubSellers());
      if (admin) {
        dispatch(getAvailableUsers());
      }
    }
  }, [loggedIn, admin, dispatch]);

  return (
    <Suspense fallback="">
      <Switch>
        <Route path={routes.SIGN_IN} component={SignIn} exact />
        <Route path={routes.RECOVER_PASSWORD} component={RecoverPassword} />
        <Route path={routes.RESET_PASSWORD} component={ResetPassword} />
        <Route isPrivate path={routes.SALES_REPORTS} component={SalesReports} exact />
        <Route isPrivate path={routes.SALES_DETAILS} component={SalesDetails} exact />
        <Route isPrivate path={routes.FINANCIAL_AGENDA} component={FinancialAgenda} exact />
        <Route isPrivate path={routes.ALL_REPORTS} component={AllReports} exact />
        {admin ? <Route isPrivate path={routes.SUMMARY}  component={Summary} exact /> : '' }
        {admin ? <Route isPrivate path={routes.USERS_MANAGEMENT} component={UsersManagement} exact></Route> : '' }
        {admin ? <Route isPrivate path={routes.SUBSELLERS} component={Subsellers} exact></Route> : '' }
        <Route isPrivate path={routes.CHANGE_PASSWORD} component={ChangePassword} exact />
        <Route isPrivate path={routes.FINANCES} component={Finances} exact />
        <Route isPrivate path={routes.SCHEDULES} component={Schedules} exact />
        <Route isPrivate path={routes.SCHEDULES_SELLER} component={Schedules} exact />

        {superAdmin ? <Route isPrivate path={routes.PAYMENT_BATCHES} component={PaymentBatches} exact /> : ''}
        {superAdmin ? <Route isPrivate path={routes.PAYMENT_BATCH_ORDERS} component={PaymentBatchOrders} exact /> : ''}
        {superAdmin ? <Route isPrivate path={routes.SELLERS_BALANCES} component={SellersBalances} exact /> : ''}
        {superAdmin ? <Route isPrivate path={routes.SIM_BANK} component={SimBank} exact /> : ''}

        <Route isPrivate path={routes.PAYMENTPLAN} component={PaymentPlan} exact />
        <Route isPrivate path={routes.READPLAN} component={ReadPlan} exact />
        {manageReconciliation || admin ? <Route isPrivate path={routes.RECONCILIATION} component={Reconciliation} exact /> : '' }

        <Route isPrivate path={routes.DETAILSRECONCILIATION} component={DetailsReconciliation} exact />
        <Route path={routes.PIX_KEY} component={PixKeyPage} exact outside />
        <Route isPrivate path={routes.PLAN_WEBHOOK_DETAILS} component={WebhookDetails} exact />
        <Route isPrivate path={routes.SUPPORT} component={Support} exact />
        <Route isPrivate path={routes.HOME} component={Home} exact />
        <Route isPrivate path={routes.FAQ} component={Faq} exact />
        <Redirect from="*" to={loggedIn ? routes.HOME : routes.SIGN_IN} />

      </Switch>
    </Suspense>
  );
}

export default Routes;
